import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';

import DatePicker     from 'app/components/common/date-picker';
import StandardSelect from 'app/components/common/standard-select';
import CavsDuck       from 'app/ducks/company-admin/cattr-vals';

class ModalEditCattrsSimple extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      selectedCattrs: {},
      dateStr: props.company.todayDateStr,
    };

    this.onChangeDate = this.onChangeDate.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
  }

  get hasChanges() {
    const any = !!Object.keys(this.changedCattrs).length;
    let firstTime = false;
    let changed = false;
    const cattrIds = [];
    Object.entries(this.changedCattrs).forEach(([cattrId, optionId]) => {
      if (this.props.cattrs[cattrId] == optionId) return; // allow undefined and null to match here
      const isFirstTime = !!optionId && !this.hasHadValue(cattrId);
      if ( isFirstTime) firstTime = true;
      if (!isFirstTime) {
        changed = true;
        cattrIds.push(cattrId);
      }
    });
    return {any, firstTime, changed, cattrIds};
  }

  get needsAsOf() {
    return this.hasChanges.changed;
  }

  get asOfValidation() {
    if (!this.needsAsOf) return null;
    const isFuture = this.state.dateStr > this.props.company.todayDateStr;
    if (!isFuture) return null;
    return {asOf: ['can not be future date']};
  }

  get changedCattrs() {
    const savedCattrs = this.props.cattrs;
    const cattrs = {};
    Object.entries(this.state.selectedCattrs).map(([key, val]) => {
      if (savedCattrs[key] != val) {
        cattrs[key] = val;
      }
    });
    return cattrs;
  }

  get mergedCattrs() {
    return {...this.props.cattrs, ...this.state.selectedCattrs};
  }

  hasHadValue(cattrId) {
    const {cattrVals} = this.props;
    if (!cattrVals) return false;
    return cattrVals.some((cv) => {
      if (cv.customAttributeId !== cattrId) return false;
      return cv.customAttributeOptionId;
    });
  }

  onSelectCattr(cattr, optionId) {
    this.setState((prevState) => {
      const selectedCattrs = {...prevState.selectedCattrs};
      selectedCattrs[cattr.id] = optionId || null;
      return {selectedCattrs};
    });
  }

  onChangeDate(dateStr) {
    this.setState({dateStr});
  }

  onClickSave() {
    this.props.save(this.changedCattrs, this.state.dateStr).then(() => {
      this.props.onClose();
    });
  }

  render() {
    const {updatePending, changePending} = this.props;
    const saveDisabled = changePending || !this.hasChanges.any || !!this.asOfValidation;

    return (
      <div className="modal-emp-cattrs-smp">
        {this.props.companyCattrs.map((cattr) => {
          const inputOpts = cattr.options.map((o) => {
            return {label: o.name, value: o.id};
          });
          const selectionOption = cattr.options.find(o => o.id === this.mergedCattrs[cattr.id]);
          const isChanged = this.hasChanges.cattrIds.includes(cattr.id);
          return (<React.Fragment key={cattr.id}>
            <label className={`bform-h3`}>
              <span>{cattr.name}</span>
              {isChanged && <span className="dot after yellow" />}
            </label>
            <StandardSelect options={inputOpts} onSelect={this.onSelectCattr.bind(this, cattr)} value={selectionOption?.id} allowClear label="No Value" />
          </React.Fragment>);
        })}

        <div className="bform-actions">
          <div className="bform-actions-right">
            {this.needsAsOf && (
              <div className="modal-emp-cattrs-smp-asof">
                <label className="modal-emp-cattrs-smp-asof-label"><span className="dot yellow before" />Backdate changes to:</label>
                <DatePicker onChange={this.onChangeDate} dateStr={this.state.dateStr} name="asOf" validations={this.asOfValidation} noFuture />
              </div>
            )}
            <button className="btn blue" onClick={this.onClickSave} disabled={saveDisabled}>{updatePending ? 'Saving...' : 'Save'}</button>
          </div>
        </div>
      </div>
    );
  }

}

ModalEditCattrsSimple.propTypes = {
  company: PropTypes.object.isRequired,
  companyCattrs: PropTypes.arrayOf(PropTypes.object).isRequired,
  onClose: PropTypes.func.isRequired,
};
ModalEditCattrsSimple.defaultProps = {};

const stateToProps = (state) => ({
  cattrs: CavsDuck.Slx.cattrs(state),
  cattrVals: CavsDuck.Slx.cattrVals(state),
  updatePending: CavsDuck.Slx.updateCattrsPending(state),
  changePending: CavsDuck.Slx.changePending(state),
});
const dispatchToProps = (dispatch) => ({
  save: (cattrs, asOf) => dispatch(CavsDuck.Ax.updateCattrs(cattrs, asOf)),
});

export default connect(stateToProps, dispatchToProps)(ModalEditCattrsSimple);
